<template>
  <li class='navigation-header mt-2' :class="{ 'nav-header--collapsed': collapsed }">
    <span>{{ $t(`menu.${item.header}`) }}</span>
    <button
      v-if="collapsible"
      type="button"
      class="nav-collapse-btn"
      :aria-label="collapsed ? 'Expand section' : 'Collapse section'"
      @click.stop="$emit('toggle')"
    >
      <feather-icon :icon="collapsed ? 'ChevronDownIcon' : 'ChevronUpIcon'" size="14"/>
    </button>
  </li>
</template>

<script>

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
    collapsible: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.navigation-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.nav-collapse-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: inherit;
  opacity: 0.55;
  cursor: pointer;
  flex-shrink: 0;
  transition: opacity 0.15s ease, background 0.15s ease;
}
.nav-collapse-btn:hover {
  opacity: 1;
  background: rgba(115, 103, 240, 0.12);
}
</style>
